export default {
  topBarContainer: {
    textAlign: 'center',
  },
};
